import SEO_CONFIG from '@/lib/seo-config';

/**
 * Google Analytics 4 Component
 * The gtag.js script is loaded directly in public/index.html so that
 * Google's tag verification crawler can detect it in the raw HTML.
 * This component is kept as a no-op for backward compatibility with
 * existing imports in App.js.
 */
export default function GoogleAnalytics() {
  return null;
}

/**
 * Track page views - call this on route changes
 * @param {string} path - The page path
 * @param {string} title - The page title
 */
export function trackPageView(path, title) {
  if (window.gtag && SEO_CONFIG.googleAnalyticsId) {
    window.gtag('config', SEO_CONFIG.googleAnalyticsId, {
      page_path: path,
      page_title: title,
    });
  }
}

/**
 * Track custom events
 * @param {string} action - Event action (e.g., 'click', 'sign_up')
 * @param {string} category - Event category (e.g., 'engagement', 'conversion')
 * @param {string} label - Event label (optional)
 * @param {number} value - Event value (optional)
 */
export function trackEvent(action, category, label, value) {
  if (window.gtag && SEO_CONFIG.googleAnalyticsId) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
}

/**
 * Track conversions (for ad campaigns)
 * @param {string} conversionId - Conversion ID from Google Ads
 */
export function trackConversion(conversionId) {
  if (window.gtag) {
    window.gtag('event', 'conversion', {
      send_to: conversionId,
    });
  }
}

/**
 * Track sign up events
 * @param {string} method - Sign up method (email, google, github)
 */
export function trackSignUp(method) {
  trackEvent('sign_up', 'engagement', method);
}

/**
 * Track purchase/subscription events
 * @param {Object} transaction - Transaction details
 */
export function trackPurchase(transaction) {
  if (window.gtag && SEO_CONFIG.googleAnalyticsId) {
    window.gtag('event', 'purchase', {
      transaction_id: transaction.id,
      value: transaction.value,
      currency: 'USD',
      items: transaction.items,
    });
  }
}
